export const COPIED_STATE_RESET_TIMEOUT = 5000
